<template>
  <v-app>
    <!-- ヘッダー-->
    <v-app-bar
      :color="headerColor"
      dark
      app
      clipped-left
      elevate-on-scroll
      dense
    >
      <!-- ヘッダー タイトル-->
      <img src="./assets/OilMatrix_BLGR_grd_cropped.png" height="35" @click="gotoTop" class="img_link">
      <v-card flat tile :color="headerColor" class="ml-3 d-none d-md-flex" >
        <v-toolbar-title @click="gotoTop" class="img_link"><template v-if="env != undefined">これは{{env}}環境です </template> OilMatrix ジャパン・アナリスト™ <template v-if="maintenance != 'none'"> {{runmode}} </template></v-toolbar-title>
      </v-card>

      <v-card flat tile :color="headerColor" class="d-none d-md-flex">
        <v-toolbar-items v-if="signedIn">
          <v-menu offset-y>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" text>メニュー<v-icon color="amber">mdi-menu-down</v-icon></v-btn>
            </template>
            <v-list>
              <v-list-item v-for="support in mysupports" :key="support.name" :to="support.link">
                <v-list-item-icon>
                  <v-icon>{{ support.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ support.name }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-card>


      <v-card flat tile :color="headerColor" class="ml-auto d-none d-md-flex">
      <v-toolbar-items v-if="signedIn">
        <v-menu offset-y>
            <template v-slot:activator="{on}">
              <v-chip v-if="isStaff" label small color="amber" class="black--text mr-3" @click="changeOffice"><v-icon class="mr-1" small>mdi-home</v-icon>{{operatingOfficeName}}</v-chip>
              <v-chip v-else-if="!isAdmin" label small color="green" class="mr-3"><v-icon class="mr-1" small>mdi-home</v-icon>{{operatingOfficeName}}</v-chip>
              <v-chip v-else label small color="green" class="mr-3" @click="changeOffice"><v-icon class="mr-1" small>mdi-home</v-icon>{{operatingOfficeName}}</v-chip>
              <v-btn v-on="on" text>{{ username }} 様<v-icon color="amber">mdi-menu-down</v-icon></v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                <div class="caption">{{ getPermission(permission) }}</div> <div class="caption">{{ email }}</div>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="signout">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title data-logout>ログアウト</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="changePassword">
                <v-list-item-icon>
                  <v-icon>mdi-account-key</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title data-logout>パスワード変更</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="isAdmin" @click="changeOffice">
                <v-list-item-icon>
                  <v-icon>mdi-home</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title data-logout>事業所の切り替え</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="isSystemAdmin" @click="changePermit">
                <v-list-item-icon>
                  <v-icon>mdi-account-cog</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>権限の切り替え</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
        </v-menu>
      </v-toolbar-items>
      </v-card>

      <v-card flat tile :color="headerColor" class="ml-auto d-sm-flex d-md-none">
        <v-btn
        outlined
        :color="headerColor"
        @click.stop="drawerxs = !drawerxs"
      >
          <v-icon color="white">mdi-menu</v-icon>
        </v-btn>
      </v-card>

        <v-navigation-drawer
          v-model="drawerxs"
          absolute
          light
          right
          temporary
          height="full"
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="mt-2 font-weight-bold title">{{ name }} 様</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <div class="caption ml-3 mb-3 black--text">
            <span><v-icon class="mr-1" small>mdi-home</v-icon>
            {{ $store.state.operatingOffice.CompanyName | truncate}}</span>
            <br>
            <span class="ml-6">{{$store.state.operatingOffice.Name | truncate}} </span>
          </div>
          <v-divider></v-divider>              

          <v-list-item v-for="support in mysupports" :key="support.name" :to="support.link">
            <v-list-item-icon>
              <v-icon>{{ support.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ support.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="signout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title data-logout>ログアウト</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="changePassword">
            <v-list-item-icon>
              <v-icon>mdi-account-key</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title data-logout>パスワード変更</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isAdmin" @click="changeOffice">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title data-logout>事業所の切り替え</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item @click="drawerxs=false">
            <v-list-item-content>
              <v-list-item-title data-close>閉じる</v-list-item-title>
            </v-list-item-content>
          </v-list-item>


         </v-navigation-drawer>
      </v-app-bar>

      <!-- メインエリア -->
      <v-content>
        <!-- <v-container class="lighten-5 px-0 pb-0">
        <div class="my-3">
          <span class="body-1 mx-3" id="nonprint">{{operatingOfficeName}}</span>
        </div>
        </v-container> -->
        <div v-if="pleaseReload" style="text-align:center;" class="ml-3 my-3">
            <span class="red--text">新しいバージョンが公開されています。Ctrl + F5（Macをお使いの場合はCommand ＋ R）を押して最新バージョンへの更新をお願いします。</span>
<!--
            <v-chip label color="amber" class="black--text mt-4" @click="versionup"><v-icon class="mr-1" small>mdi-cloud-download</v-icon>新しいバージョンをダウンロード</v-chip>
-->
            <br><br>
            <v-icon class="mr-1">mdi-cloud-download</v-icon><a :href="verupURL">新しいバージョンをダウンロード</a>
        </div>

        <div v-if="isMaintenance" style="text-align:center;" class="ml-3 my-3">
          ただいまメンテナンス作業中です<br>
          申し訳ございませんが、お時間をおいて再度アクセスして下さい。<br>
          <br>
          {{maintenanceMessage}}
        </div>
<!--
        <div style="text-align:center;" class="ml-3 my-3">{{getMaintenanceMode}}</div>
-->
        <router-view v-if="!isMaintenance && !pleaseReload" />

        <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
          <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
        </v-overlay>
        <v-overlay absolute :value="overlayStepper2" opacity="0.8" color="white">
          <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
        </v-overlay>

      </v-content>

      <!-- フッター -->
      <!-- <v-footer color="grey darken-3" dark app clipped-left class="d-none d-md-flex">
        Copyright © 2020 Japan Analyst Co., Ltd. All Rights Reserved.
      </v-footer> -->
      <v-footer color="grey darken-3" dark id="nonprint" class="text--center">
        <span ID="footerxs" class="caption">Copyright © 2020 Japan Analyst Co., Ltd. All Rights Reserved.</span>
        <v-spacer></v-spacer>
        <span class="caption">ver.{{currentVersion}}</span>
        <span class="caption ml-3"> mode.{{this.maintenance}}</span>
      </v-footer>

  </v-app>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { Auth } from 'aws-amplify'
import { officeByKey, } from './graphql/queries'
import { companyByKey, } from './graphql/queries'
import { employeeByUserPool, } from './graphql/queries'
import { configureByKey, } from './graphql/queries'
//import { AmplifyEventBus } from 'aws-amplify-vue'
import { Hub } from "@aws-amplify/core"

import initcore  from './utils/initialize.js'

export default {
  mixins:[initcore],

  
    data(){
    return{
      env: "",
      maintenance: "",
      maintenanceMessage: "",
      runmode: "",
      currentVersion: "2025-20261004",
      pleaseReload: false,
      drawer: null,
      drawerxs: false,
      overlayStepper1: true,
      overlayStepper2: true,
//      companyname: "",
//      officename: "",
      name: "",
      supports:[
        {
          name: 'スタッフTOP',
          icon: 'mdi-file-send',
          link:'/staffpage',
          role:'10000001',
          isStaffOnly: true
        },
        {
          name: 'ENEOS様向け分析依頼登録',
          icon: 'mdi-account-multiple',
          link:'/application_jxtg',
          role:'10000001',
          isStaffOnly: true
        },
        {
          name: 'メンテナンスメニュー',
          icon: 'mdi-cog',
          link:'/maintenance',
          role:'10000001',
          isStaffOnly: true
        },
        {
          name: 'お申込み',
          icon: 'mdi-file-send',
          link:'/',
          role:'10000001',
          isStaffOnly: false
        },
        {
          name: 'マイ機器',
          icon: 'mdi-forklift',
          link:'/mymachinelist',
          role:'10000001',
          isStaffOnly: false
        },

        {
          name: '納品明細書・報告書一覧',
          icon: 'mdi-file-send',
          link:'/deliverablelist',
          role:'10000001',
          isStaffOnly: false
        },

        {
          name: '担当者',
          icon: 'mdi-account-multiple',
          link:'/employeelist',
          role:'10000009',
          isStaffOnly: false
        },
      ],

      signedIn: false,
      username: '',
      email: '',
      permission: '',
    }
  },
  filters: {
    truncate: function(value) {
      var length = 15
      if(value) {
        if (value.length <= length ) {
          return value
        }
        return value.substring(0, length) + '..'
      }
    }
  },
  computed: {
    headerColor: function() {
      if(this.env == "stg") {
        return "blue darken-3"
      }else if(this.env == "dev") {
        return "green darken-3"
//        return "grey darken-3"
      }else {
        return "grey darken-3"
      }
    },
    operatingOfficeName: function() {
      if(this.$store.state.initializedUser) {
        return this.$store.state.operatingOffice.CompanyName + " " + this.$store.state.operatingOffice.Name
      }else{
        return ""
      }
    },
    mysupports: function () {
      let _supports = this.supports.filter(item => item.role <= this.$store.state.employee.Permission)
      //スタッフ向けメニューの表示/非表示
      if(this.$store.state.isStaff == false) {
        _supports = _supports.filter(item => item.isStaffOnly <= false)
      }
      return _supports
    },
    isAdmin () {
      return this.$store.state.isAdmin
    },
    isSystemAdmin () {
      console.log("this.$store.state.isSystemAdmin", this.$store.state.isSystemAdmin)
      return this.$store.state.isSystemAdmin
    },
    isMaintenance () {
      if(this.$store.state.isSystemAdmin) {
        return false
      }
      
      if(this.maintenance == "none") {
        return false
      }else if(this.maintenance == "all") {
        return true
      }else if(this.maintenance == "public") {
        if(this.$store.state.isStaff){
          return false
        }else {
          return true
        }
      }else {
        return false;
      }
    },
    isStaff () {
      return this.$store.state.isStaff
    },
    getMaintenanceMode () {
      if(this.maintenance == "none") {
        return ""
      }else if(this.maintenance == "all") {
        return "メンテナンス中"
      }else if(this.maintenance == "public") {
        return "メンテナンス中"
      }else {
       return ""
      }
    },
    verupURL () {
      return "/?v="+ this.currentVersion
    },
  },
  updated: async function () {
    this.$nextTick(async function () {
      // ビュー全体が再レンダリングされた後にのみ実行されるコード
      let _maintenance = await API.graphql(graphqlOperation(configureByKey, {Key: "maintenance"}))
      let maintenance = _maintenance.data.configureByKey.items[0]
      this.maintenance = maintenance.Value

      if(this.maintenance != "none"){
        this.runmode = "閉塞中"
        console.log('★★★maintenance', this.maintenance)
        console.log('maintenanceMessage', this.maintenanceMessage)

        let _maintenanceMessage = await API.graphql(graphqlOperation(configureByKey, {Key: "maintenanceMessage"}))
        let maintenanceMessage = _maintenanceMessage.data.configureByKey.items[0]
        this.maintenanceMessage = maintenanceMessage.Value
      }else {
        this.runmode = ""
        let _currentVersion = await API.graphql(graphqlOperation(configureByKey, {Key: "currentVersion"}))
        let currentVersion = _currentVersion.data.configureByKey.items[0]
        let dbCurrentVersion = currentVersion.Value

//        console.log('★★★CurrentVersion', this.currentVersion)
//        console.log('★★★dbCurrentVersion', dbCurrentVersion)
        if(this.currentVersion != dbCurrentVersion) {

          // スマホのapplicationキャッシュクリア対応
          window.navigator.serviceWorker.getRegistrations()
          .then(registrations => {
            for(let registration of registrations) {
              registration.unregister();
            }
          });

          console.log('please newest reload', dbCurrentVersion)
          console.log('Current Version', this.currentVersion)
          this.pleaseReload = true
        }
      }
    })
  },
  mounted: async function() {
/*
    let _currentVersion = await API.graphql(graphqlOperation(configureByKey, {Key: "currentVersion"}))
    let currentVersion = _currentVersion.data.configureByKey.items[0]
    let dbCurrentVersion = currentVersion.Value

    console.log('★★★CurrentVersion', this.currentVersion)
    console.log('★★★dbCurrentVersion', dbCurrentVersion)
    if(this.currentVersion != dbCurrentVersion) {
      console.log('please newest reload', dbCurrentVersion)
      this.pleaseReload = true
    }
*/
    this.env = process.env.VUE_APP_ENV
    console.log("■■env:", this.env)
    if(!this.env) {
    console.log("■■env定義なし", this.env)
    }
  },
  // storeの初期化処理
  async created() {
    console.log('■■start created')

    await this.initUser()
    this.name = this.$store.state.employee.Name
    this.username = this.name
    this.permission = this.$store.state.employee.Permission
    this.email = this.$store.state.employee.email

    await this.initAnalizeInfo()

    this.overlayStepper1 = false
  },
  async beforeCreate() {
    console.log('■■start beforeCreate')
    // 認証ステータスが変わった時に呼び出されるイベントを登録
//    AmplifyEventBus.$on('authState', async  info => {
    Hub.listen("auth", async (info) => {
      console.log("■■ beforeCreate authState", info.payload.event)
//      if (info === 'signedIn') {
      if (info.payload.event === 'signIn') {
        console.log("■■ Auth signIn event detected")
        
        // 初期化中の場合は処理をスキップ
        if (this.$store.state.initializedUser) {
          console.log("■■ User already initialized, skipping")
          return
        }

        this.$store.commit('setInitializedUser', false )
        const initResult = await this.initUser()
        
        if (initResult) {
          this.name = this.$store.state.employee.Name
          this.username = this.name
          this.permission = this.$store.state.employee.Permission
          this.email = this.$store.state.employee.email

          await this.initAnalizeInfo()
          this.signedIn = true
        }
      } else if (info.payload.event === 'signOut') {
        console.log("■■ Auth signOut event detected")
        this.signedIn = false
        this.$store.commit('setInitializedUser', false )
        this.$store.commit('setInitializedAnalize', false )
      }
    });
  },
  methods:{
    async signout() {
      try {
        await this.$Amplify.Auth.signOut();
        this.signedIn = false;
        this.$store.commit('setInitializedUser', false )
        this.$store.commit('setInitializedAnalize', false )
        this.$router.push("/auth");
      } catch (e) {
        console.log(e);
      }
    },
    async changePassword() {
        this.$router.push("/changePassword");
    },
    async changeOffice() {
        this.$router.push("/changeOffice");
    },
    async changePermit() {
        this.$router.push("/ChangePermit");
    },
    async gotoTop() {
        this.$router.push("/");
    },
    async versionup () {
      this.$router.push("/?v="+ this.currentVersion).catch(()=>{});
    },

  async initUser() {
      console.log("■■ standby InitUser wait", this.$store.state.initializedUser)
      try {
        if(!this.$store.state.initializedUser) {
          console.log("■■ InitUser start")
          let cognitoUser = await Auth.currentAuthenticatedUser()
          console.log("■■ cognitoUser obtained:", cognitoUser.username)

          let _employee = await API.graphql(graphqlOperation(employeeByUserPool, {UserPoolID: cognitoUser.username}))
          let employee = _employee.data.employeeByUserPool.items[0]
          
          if (!employee) {
            console.error("■■ Employee not found for user:", cognitoUser.username)
            return false
          }
          console.log("■■ employee obtained:", employee.Name)

          let officeid = employee.OfficeID
          let office = await API.graphql(graphqlOperation(officeByKey, {OfficeID: officeid}))
          let myoffice = office.data.officeByKey.items[0]
          
          if (!myoffice) {
            console.error("■■ Office not found for ID:", officeid)
            return false
          }
          console.log("■■ office obtained:", myoffice.Name)

          let company = await API.graphql(graphqlOperation(companyByKey, {CompanyID: myoffice.CompanyID}))
          let mycompany = company.data.companyByKey.items[0]
          
          if (!mycompany) {
            console.error("■■ Company not found for ID:", myoffice.CompanyID)
            return false
          }
          console.log("■■ company obtained:", mycompany.Name)
          
          this.$store.commit('setMyCompany',mycompany )

          // 企業名、事業所名の変更は担当者（Employee）連携時に反映されない
          // 各マスタの名称で上書きする
          myoffice["CompanyName"] = mycompany.Name
          myoffice["PaymentOfficeID"] = mycompany.PaymentOfficeID

          this.$store.commit('setMyOffice',myoffice )

          employee["CompanyName"] = mycompany.Name
          employee["OfficeName"] = myoffice.Name
          this.$store.commit('setEmployee',employee )

          if(employee.Permission == "99999999") { // システム管理者（スーパーユーザー）
            this.$store.commit('setAdmin', true )
            this.$store.commit('setSystemAdmin', true )
            this.$store.commit('setUserAdmin',true )
            this.$store.commit('setSuperUser', true )
            this.$store.commit('setDeveloper', false )
          }else if(employee.Permission == "99999990") { // システム管理者（一般スタッフ）
            this.$store.commit('setAdmin', true )
            this.$store.commit('setSystemAdmin', true )
            this.$store.commit('setUserAdmin',true )
            this.$store.commit('setSuperUser',false )
            this.$store.commit('setDeveloper',false )
          }else if(employee.Permission == "77777777") { // 開発者（β機能など利用可） 
            this.$store.commit('setAdmin', true )
            this.$store.commit('setSystemAdmin', true )
            this.$store.commit('setUserAdmin',true )
            this.$store.commit('setSuperUser',true )
            this.$store.commit('setDeveloper',true )
          }else if(employee.Permission == "10000009") { // 事業所管理者
            this.$store.commit('setAdmin', true )
            this.$store.commit('setSystemAdmin', false )
            this.$store.commit('setUserAdmin',true )
            this.$store.commit('setSuperUser',false )
            this.$store.commit('setDeveloper',false )
          }else { // 一般利用者
            this.$store.commit('setAdmin', false )
            this.$store.commit('setSystemAdmin', false )
            this.$store.commit('setSuperUser',false )
            this.$store.commit('setDeveloper',false )
          }

//          if(mycompany.CompanyID == "0000000000"){
          if((mycompany.CompanyID == "0000000000") || (mycompany.CompanyID == "9999999998")){
            this.$store.commit('setStaff', true )
          }else {
            this.$store.commit('setStaff', false )
          }

          this.$store.commit('setInitializedUser', true )
          console.log("■■ InitUser completed successfully")
        } else {
          console.log("■■ InitUser already initialized")
        }
        this.signedIn = true
        return true
      }catch(err) {
        console.log("■■ initUser err", err)
        // エラー時は初期化フラグをfalseに戻す
        this.$store.commit('setInitializedUser', false )
        this.signedIn = false
        return false
      }
    },
    
    async initAnalizeInfo() {
      try {
        this.overlayStepper2 = true
        await this.initAnalizeInfoCore()

        this.overlayStepper2 = false
      }catch(err) {
        console.log("■■ initAnalizeInfo err", err)
        this.overlayStepper2 = false
      }
    },
    getPermission (Permission) {
      if (Permission == "00000001") return '未許可'
      else if (Permission == "10000000") return '選択可'
      else if (Permission == "10000001") return '一般担当者'
      else if (Permission == "10000009") return '事業所管理者'
      else if (Permission == "99999990") return 'システム管理者'
      else if (Permission == "99999999") return 'スーパーユーザー'
      else if (Permission == "77777777") return '開発者'
      else return Permission
    }
  }
};
</script>
<style>
  .img_link {
  cursor: pointer;
  }
	@media screen and (max-width: 480px) {
    #title {
        font-size: 20px !important;
        padding: 3px !important;
        margin: 0px !important;
    }
    #card-title {
      font-size: 16px !important;
      padding: 3px !important;
    }
    #card-subject {
      font-size: 14px !important;
    }
    #card-subject2 {
      font-size: 11px !important;
    }
    #footerxs {
      font-size: 10px !important;      
    }
  }
</style>